export default __webpack_public_path__ + "static/media/vellum.c96873b6.jpg";